import { http } from "config/http";


export const getFileProcessing = async () => {
    try {
        const res: any = await http.get(`get_all_file_request?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}


export const postFileProcessing = async (body: { user_name: string, file : any }) => {

    try {
        const res: any = await http.post(`file_processing?user_name=${body.user_name}&client_env=${localStorage.getItem("clientName")}`, body.file)
        
        return { resultApproval: res}
    } catch (error: any) {
        return { errorApproval: error.message }
    }
}

export const approveRejectApi = async (body: { id?: number, is_approve?: string, updated_by?: string }) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.put(`admin_approve`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const deleteUserDocApi = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.put(`delete_file_request`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}